import Input from '@/components/forms/Input';
import { useDynamicLocale } from '@/hoslog-intl';
import { useFormContext } from 'react-hook-form';

export const OtherBankFields = () => {
  const { register } = useFormContext();
  const { t } = useDynamicLocale();

  return (
    <div className="grid grid-cols-1 gap-x-[18px] gap-y-6 sm:grid-cols-2">
      <div>
        <Input
          label={t('paymentManagement.adminPaymentSetup.adminBankInfo.bankName')}
          placeholder={t('common.form.placeholder.bankName')}
          maxLength={50}
          forceRequired
          {...register('bankName')}
        />
      </div>
      <div className="hidden sm:block" aria-hidden="true" />
      <Input
        label={t('paymentManagement.adminPaymentSetup.adminBankInfo.branchCode')}
        placeholder={t('common.form.placeholder.branchCode')}
        maxLength={50}
        {...register('branchCode')}
      />
      <Input
        label={t('paymentManagement.adminPaymentSetup.adminBankInfo.branchName')}
        placeholder={t('common.form.placeholder.branchName')}
        maxLength={50}
        forceRequired
        {...register('branchName')}
      />
      <Input
        label={t('paymentManagement.adminPaymentSetup.adminBankInfo.accNum')}
        placeholder={t('common.form.placeholder.accountNumber')}
        type="number"
        maxLength={50}
        forceRequired
        {...register('accountNumber')}
      />
      <Input
        label={t('paymentManagement.adminPaymentSetup.adminBankInfo.accHolderName')}
        placeholder={t('common.form.placeholder.accountHoldersName')}
        maxLength={50}
        forceRequired
        {...register('accountName')}
      />
    </div>
  );
};
